import React, {createContext, useReducer} from 'react'
import {ReceiverGroupByReducer} from "../reducers/ReceiveGroupByReducer";

export const ReceiveGroupByContext = createContext();

const ReceiveGroupByContextProvider = (props) => {
    const selectedGroup = {displayName: "None", value: ""}
    const allGroups = [
        {displayName: "None", value: ""},
        {displayName: "Package Size", value: "PackageSize"},
        {displayName: "EAD", value: "EAD"},
        {displayName: "Cycle", value: "Cycle"},
        {displayName: "Cluster", value: "Cluster"}
    ]
    const [ groups, dispatch ] = useReducer(ReceiverGroupByReducer,{selectedGroup, allGroups});
    return (
        <ReceiveGroupByContext.Provider value = {{groups, dispatch}}>
            {props.children}
        </ReceiveGroupByContext.Provider>
    )
}

export default ReceiveGroupByContextProvider


// WEBPACK FOOTER //
// ./src/components/receive/context/ReceiveGroupByContext.js